import { render, staticRenderFns } from "./bind-tour.vue?vue&type=template&id=8ca9f244&scoped=true&"
import script from "./bind-tour.vue?vue&type=script&lang=js&"
export * from "./bind-tour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ca9f244",
  null
  
)

export default component.exports